import NoImageHero from './NoImageHero';

export { type NoImageHeroProps } from './NoImageHero';
export default NoImageHero;
